import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { DROPDOWN_CATEGORY_KEY, DROPDOWN_COMPONENT_KEY } from '../Dropdown.meta.js';

export default InjectedStyledComponent('section', DROPDOWN_CATEGORY_KEY, DROPDOWN_COMPONENT_KEY, ['wrapper']);
